import { User } from '@graphics/gfx-common/dist/types'
import {
  EditionSubType,
  EditionType,
} from '@graphics/gfx-common/dist/constants'
import { IInitAction } from './init'
import { UserDateType } from './date'

// Action types
export enum types {
  CREATE_CAPABILITY__STARTED = 'CREATE_CAPABILITY__STARTED',
  CREATE_CAPABILITY__SUCCESS = 'CREATE_CAPABILITY__SUCCESS',
  CREATE_CAPABILITY__FAILURE = 'CREATE_CAPABILITY__FAILURE',
  UPDATE_CAPABILITY__STARTED = 'UPDATE_CAPABILITY__STARTED',
  UPDATE_CAPABILITY__SUCCESS = 'UPDATE_CAPABILITY__SUCCESS',
  UPDATE_CAPABILITY__FAILURE = 'UPDATE_CAPABILITY__FAILURE',
  DELETE_CAPABILITY__STARTED = 'DELETE_CAPABILITY__STARTED',
  DELETE_CAPABILITY__SUCCESS = 'DELETE_CAPABILITY__SUCCESS',
  DELETE_CAPABILITY__FAILURE = 'DELETE_CAPABILITY__FAILURE',
  GET_CAPABILITY_BY_ID__STARTED = 'GET_CAPABILITY_BY_ID__STARTED',
  GET_CAPABILITY_BY_ID__SUCCESS = 'GET_CAPABILITY_BY_ID__SUCCESS',
  GET_CAPABILITY_BY_ID__FAILURE = 'GET_CAPABILITY_BY_ID__FAILURE',
}

export interface ICreateCapabilityAction {
  type: types.CREATE_CAPABILITY__STARTED
  capabilityData: ICapability
}

export interface ICreateCapabilitySuccessAction {
  type: types.CREATE_CAPABILITY__SUCCESS
  capabilityData: ICapability
  message: string
}

export interface IGetCapabilityByIdAction {
  type: types.GET_CAPABILITY_BY_ID__STARTED
  id: string
}

export interface IGetCapabilityByIdSuccessAction {
  type: types.GET_CAPABILITY_BY_ID__SUCCESS
  capabilityData: ICapability
}

export interface IUpdateCapabilityAction {
  type: types.UPDATE_CAPABILITY__STARTED
  capabilityData: ICapability
}

export interface IUpdateCapabilitySuccessAction {
  type: types.UPDATE_CAPABILITY__SUCCESS
  capabilityData: ICapability
  message: string
}

export interface IDeleteCapabilityAction {
  type: types.DELETE_CAPABILITY__STARTED
  id: string
}

export interface IDeleteCapabilitySuccessAction {
  type: types.DELETE_CAPABILITY__SUCCESS
  message: string
}

export interface IFailureAction {
  type:
    | types.CREATE_CAPABILITY__FAILURE
    | types.GET_CAPABILITY_BY_ID__FAILURE
    | types.UPDATE_CAPABILITY__FAILURE
    | types.DELETE_CAPABILITY__FAILURE
  message: string
}

export type CapabilityType =
  | ICreateCapabilityAction
  | ICreateCapabilitySuccessAction
  | IGetCapabilityByIdAction
  | IGetCapabilityByIdSuccessAction
  | IUpdateCapabilityAction
  | IUpdateCapabilitySuccessAction
  | IDeleteCapabilityAction
  | IDeleteCapabilitySuccessAction
  | IFailureAction
  | IInitAction

export interface ICapabilityBase extends UserDateType {
  isLoading?: boolean
  message?: string
  id: string
  title: string
  description: string
  editionTypes: EditionType[]
  editionSubType?: EditionSubType | ''
  promotionLevel: string[]
  requiredMediaTypeGroupId: string
  requiredMediaTypeGroupTitle: string
  supportedMediaTypeGroupId: string
  supportedMediaTypeGroupTitle: string
  excludeMediaTypeGroupId?: string
  excludeMediaTypeGroupTitle?: string
  lifetime?: string
  requiresApproval: boolean
  approved?: boolean
  approvalDate?: string
  approvedBy?: User
}

export interface ICapability extends ICapabilityBase {
  publishingLocation?: {
    name: string
    title: string
  } | null
}

export interface ICapabilityFormValues extends ICapabilityBase {
  publishingLocation?: string
}
